import { Navigate } from "react-router-dom";
import useAuthAccess from "../../hooks/useAuthAccess";

const ProtectedAdminRoute = ({ children }) => {
  const { loading, isAuthenticated, role } = useAuthAccess();

  if (loading) {
    return (
        <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="h-14 w-14 animate-spin rounded-full border-4 border-[#c90243] border-t-transparent"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (role !== "admin") {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
